import { Client } from './client';
import { GenericFilter } from './genericClass';
import { InternalEquipmentBalanceMass } from './internalEquipmentBalanceMass';
import { InternalEquipmentCustomFieldValue } from './internalEquipmentCustomFieldValue';
import { InternalEquipmentPerformances } from './internalEquipmentPerformances';

export class InternalEquipment {

    id: number;
    group: string;

    name: string;
    equipment: string;

    maker: string;
    model: string;

    serialNum: string;
    certificateNum: string;

    idStatus: number;
    nameStatus: string;
    statusTranslation: string;

    calibrateDate: Date;
    expirationDate: Date;

    idCertificate: number;
    certificate: any;

    observations: string;

    idClient: number;
    client: Client;

    responsible: number;

    idsVariables: number[];
    idsApps: number[];
    idsFolder: number[];
    idsAction: number[];

    internal: boolean;

    supplier: string;
    fee: number;

    equipmentRange: string;
    useRange: string;
    resolution: string;
    tolerance: string;
    calibrationFrequency: string;
    acquisitionDate: Date;
    extendedExpirationDate: Date;
    expansionDay: number;

    responsibleEquipment: string;
    notificationResposibleEq: boolean;

    idEquipmentType: number;
    customFields: InternalEquipmentCustomFieldValue[];
    performances: InternalEquipmentPerformances[];
    location: string;
    hasBalance: boolean = false;
    //balanceMass: InternalEquipmentBalanceMass[] = [];
    idFileBalanceMass: number;

    clientName: string;

    multichannel: boolean;
    multichannels: InternalEquipmentMultichannel[];

}

export class InternalEquipmentFilter extends GenericFilter {
    idStatus: number[];
    idClient: number;
    group: string;

    name: string;
    type: string;

    maker: string;
    model: string;

    serialNum: string;
    certificateNum: string;

    calibrateDateStart: Date;
    calibrateDateEnd: Date;

    expirationDateStart: Date;
    expirationDateEnd: Date;

    internal = false;
    external = false;

    idsVariable: number[];
    idsApp: number[];

    supplier: string;

    equipmentRange: string;
    useRange: string;
    resolution: string;
    tolerance: string;
    calibrationFrequency: string;
    acquisitionDateStart: Date;
    acquisitionDateEnd: Date;

    idFolder: number;

    cols: string[];

    customFields: Map<number, string> | any = new Map();
    idsActions: number[];

    extendedExpirationDate: Date;
    expansionDay: number;
    idResposible: number;
    responsibleEquipment: string;
    multichannels: string [];
}

export class InternalEquipmentFilterPerformance extends GenericFilter {
    idStatus: number[];
    idClient: number;
    group: string;

    name: string;
    type: string;

    maker: string;
    model: string;

    serialNum: string;
    certificateNum: string;

    realizationDateStart: Date;
    realizationDateEnd: Date;

    expirationDateStart: Date;
    expirationDateEnd: Date;

    internal = false;
    external = false;

    idsVariable: number[];
    idsApp: number[];

    supplier: string;

    equipmentRange: string;
    useRange: string;
    resolution: string;
    tolerance: string;
    frequency: string;
    acquisitionDateStart: Date;
    acquisitionDateEnd: Date;

    idFolder: number;

    cols: string[];

    customFields: Map<number, string> | any = new Map();
    idsActions: number[];
    protocolNum: string;
    executionNum: string;
    idResposible: number;
    responsibleEquipment: string;
    hasBalance: boolean;
    idsEquipmentType: number[];
    idsAction: number[];
    clean: boolean = false;
    location: string;
}

export class InternalEquipmentTypeEnum {
  private constructor(
    public readonly id: number,
    public readonly name: string
  ) {}

  static readonly EQUIPMENTS = new InternalEquipmentTypeEnum(1, 'equipment');
  static readonly BALANCES = new InternalEquipmentTypeEnum(2, 'balance');
  static readonly MASS = new InternalEquipmentTypeEnum(3, 'mass');
  static readonly PARTICLES = new InternalEquipmentTypeEnum(4, 'particles');



  static values(): InternalEquipmentTypeEnum[] {
    return [this.EQUIPMENTS, this.BALANCES, this.MASS,this.PARTICLES];
  }

  static fromId(id: number): InternalEquipmentTypeEnum | undefined {
    return this.values().find(item => item.id === id);
  }

  static fromName(name: string): InternalEquipmentTypeEnum | undefined {
    return this.values().find(item => item.name === name);
  }
}

export class InternalEquipmentMultichannel {
    id: number;
    idEquiment: number;
    description: string;
    position: number;
    active: boolean;
    reasonActive: string;
    uuid: string;
}

export class InternalEquipmentTecnicalInformation {
  id: number;
  idEquipment: number;
  contact: string;
  clientObservation: string;
  service: string;
  serviceDescription: string;
  serviceRecommendations: string;
  serviceOperational: string;
  serviceOperationalDescription: string;
  result: string;
  idAttachment: number;
}

export class InternalEquipmentForPattern {
    id: number
    idEquipment: number
    name: string;
    serialNum: string;
    idActionType: number;
    idMultichannel: number;
    description: string;
    expirationDate: Date;
    nearToExpire: boolean;
    expired: boolean;
    equipment: InternalEquipment;
}
